import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const PrivacyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={styles.overlay}
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.3 }}
          style={styles.modal}
          onClick={e => e.stopPropagation()}
        >
          <button style={styles.closeButton} onClick={onClose}>
            ✕
          </button>

          <h2 style={styles.title}>ПРИВАТНОСТЬ</h2>

          <div style={styles.content}>
            <p style={styles.highlight}>
              <strong>Главное:</strong> «Настройка на Ясность» 
              не собирает, не хранит и не обрабатывает никакие персональные данные пользователей.
            </p>

            <h3 style={styles.subtitle}>Что мы НЕ делаем</h3>
            <ul style={styles.list}>
              <li>Не собираем персональные данные</li>
              <li>Не используем cookies для отслеживания</li>
              <li>Не устанавливаем системы аналитики (Google Analytics, Яндекс.Метрика и т.д.)</li>
              <li>Не требуем регистрации или авторизации</li>
              <li>Не передаём данные третьим лицам</li>
              <li>Не показываем рекламу</li>
            </ul>

            <h3 style={styles.subtitle}>Как работает «Настройка на ясность»</h3>
            <p style={styles.text}>
              «Настройка на ясность» — это веб-приложение (PWA), 
              которое работает полностью на стороне вашего устройства:
            </p>
            <ul style={styles.list}>
              <li>Все данные о прогрессе хранятся локально в вашем браузере (localStorage)</li>
              <li>Никакие данные не отправляются на сервер</li>
              <li>Приложение работает офлайн после первой загрузки</li>
              <li>Вы можете удалить все данные, очистив кэш браузера</li>
            </ul>

            <h3 style={styles.subtitle}>Хостинг</h3>
            <p style={styles.text}>
              Приложение размещено на платформе Timeweb Cloud. Хостинг-провайдер может вести 
              стандартные серверные логи (IP-адреса, время запросов), которые автор 
              не просматривает и не анализирует.
            </p>

            <h3 style={styles.subtitle}>Внешние ссылки</h3>
            <p style={styles.text}>
              Приложение содержит ссылки на внешние ресурсы (Telegram). 
              Эти сервисы имеют собственные политики конфиденциальности, за которые мы не несём ответственности.
            </p>

            <h3 style={styles.subtitle}>Шрифты</h3>
            <p style={styles.text}>
              Приложение использует шрифты Google Fonts, которые загружаются с серверов Google. 
              Google может собирать техническую информацию о запросах шрифтов согласно своей политике конфиденциальности.
            </p>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.9)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: '20px',
  },
  modal: {
    background: '#1a1a1a',
    borderRadius: '20px',
    padding: '32px 24px',
    maxWidth: '480px',
    width: '100%',
    maxHeight: '80vh',
    overflowY: 'auto',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    width: '32px',
    height: '32px',
    border: 'none',
    background: 'transparent',
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: '18px',
    cursor: 'pointer',
  },
  title: {
    color: '#E5D2A0',
    fontSize: '16px',
    fontWeight: '600',
    letterSpacing: '4px',
    textAlign: 'center',
    marginBottom: '24px',
  },
  content: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '14px',
    lineHeight: '1.7',
  },
  highlight: {
    background: 'rgba(229, 210, 160, 0.1)',
    padding: '16px',
    borderRadius: '12px',
    marginBottom: '24px',
  },
  subtitle: {
    color: '#E5D2A0',
    fontSize: '13px',
    fontWeight: '600',
    letterSpacing: '1px',
    marginTop: '20px',
    marginBottom: '12px',
  },
  text: {
    marginBottom: '12px',
  },
  list: {
    marginLeft: '20px',
    marginBottom: '12px',
  },
};

export default PrivacyModal;